export function componentNavigation() {
    Alpine.data('navigation', () => ({
        user_is_logged_in: false,
        is_menu_open: false,
        is_search_open: false,
        is_user_open: false,

        init() {
            this.user_is_logged_in = (site_objects.user_is_logged_in === 'true');
        },

        trigger_menu: {
            ["@click"](e) {
                this.is_menu_open = !this.is_menu_open
                this.is_search_open = false
                this.is_user_open = false
            },
        },

        header: {
            ["x-bind:class"]() {
                return {
                    'modal-is-open': (this.is_menu_open || this.is_search_open || this.is_user_open),
                    'modal-is-close': (!this.is_menu_open && !this.is_search_open && !this.is_user_open),
                }
            },
        },

        trigger_search: {
            ["@click"](e) {
                this.is_search_open = !this.is_search_open
                this.is_menu_open = false
                this.is_user_open = false
            },
        },

        show_navigation_modal: {
            ["x-show"]() {
                return this.is_menu_open
            },
            ["x-on:keydown.escape.prevent.stop"]() {
                this.is_menu_open = false
            },
        },

        navigation_overlay: {
            ["x-show"]() {
                return this.is_menu_open
            }
        },

        navigation_panel: {
            ["x-show"]() {
                return this.is_menu_open
            },
        },

        show_search_modal: {
            ["x-show"]() {
                return this.is_search_open
            },
            ["x-on:keydown.escape.prevent.stop"]() {
                this.is_search_open = false
            },
        },

        search_overlay: {
            ["x-show"]() {
                return this.is_search_open
            }
        },

        search_panel: {
            ["x-show"]() {
                return this.is_search_open
            },
        },

        trigger_user: {
            ["@click"](e) {
                this.is_user_open = !this.is_user_open
                this.is_menu_open = false
                this.is_search_open = false
            },
        },

        show_user_modal: {
            ["x-show"]() {
                return this.is_user_open
            },
            ["x-on:keydown.escape.prevent.stop"]() {
                this.is_user_open = false
            },
        },

        user_overlay: {
            ["x-show"]() {
                return this.is_user_open
            }
        },

        user_panel: {
            ["x-show"]() {
                return this.is_user_open
            },
        },

        user_log_out(){
            let formData = new FormData();
            formData.append('action', 'mh_log_user_out');
            formData.append('_wpnonce', site_objects.wp_nonce);

            fetch(site_objects.ajax_url, {
                method: 'POST',
                body: formData
            }).then((res) => res.json())
                .then((res) => {
                    if(!res.success){
                        console.log(res.data)
                    }else{
                        window.location.href = res.data.redirect_to
                    }
                })
        }
    }))
}